/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenQrBidvEntity } from '../models/GenQrBidvEntity';
import type { GenQrBidvVADto } from '../models/GenQrBidvVADto';
import type { GenQrBidvVAEntity } from '../models/GenQrBidvVAEntity';
import type { InquiryBidvVAEntity } from '../models/InquiryBidvVAEntity';
import type { SyncTransactionsBidvVAEntity } from '../models/SyncTransactionsBidvVAEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BidvVirtualAccountService {
  /**
   * Tạo mã QR cho BIDV Virtual Account
   * @param vaPrefix VA Prefix of the owning Company
   * @param endCode End Code / Payer ID
   * @param requestBody
   * @returns GenQrBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerGenQr(
    vaPrefix: string,
    endCode: string,
    requestBody?: GenQrBidvVADto,
  ): CancelablePromise<GenQrBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/qr',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Lấy mã QR của BIDV Virtual Account
   * @param vaPrefix VA Prefix of the owning Company
   * @param endCode End Code / Payer ID of the Virtual Account
   * @returns GenQrBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerGetQr(
    vaPrefix: string,
    endCode: string,
  ): CancelablePromise<GenQrBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/qr',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
    });
  }

  /**
   * Lấy mã QR BIDV kèm số tiền
   * @param vaPrefix VA Prefix of the owning Company
   * @param endCode End Code / Payer ID of the Virtual Account
   * @param amount QR payment amount
   * @param description Optional QR description
   * @returns GenQrBidvEntity
   * @throws ApiError
   */
  public static bidvVaControllerGetQrWithAmount(
    vaPrefix: string,
    endCode: string,
    amount: string,
    description?: string,
  ): CancelablePromise<GenQrBidvEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/qr-with-amount',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      query: {
        amount: amount,
        description: description,
      },
    });
  }

  /**
   * Tra cứu giao dịch BIDV Virtual Account
   * @param vaPrefix VA Prefix of the owning Company
   * @param endCode End Code / Payer ID
   * @param startDate Start date for inquiry in strict ISO 8601 format.
   * @param endDate End date for inquiry in strict ISO 8601 format.
   * @returns InquiryBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerInquiry(
    vaPrefix: string,
    endCode: string,
    startDate?: string,
    endDate?: string,
  ): CancelablePromise<InquiryBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/inquiry',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      query: {
        startDate: startDate,
        endDate: endDate,
      },
    });
  }

  /**
   * Đồng bộ giao dịch BIDV bị thiếu callback
   * @param vaPrefix VA Prefix of the owning Company
   * @param endCode End Code / Payer ID
   * @param startDate Start date for inquiry in strict ISO 8601 format.
   * @param endDate End date for inquiry in strict ISO 8601 format.
   * @returns SyncTransactionsBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerSyncTransactions(
    vaPrefix: string,
    endCode: string,
    startDate?: string,
    endDate?: string,
  ): CancelablePromise<SyncTransactionsBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/sync-transactions',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      query: {
        startDate: startDate,
        endDate: endDate,
      },
    });
  }
}
